// Colour triples (bg, text, dot) for the "Tipo" and "Estado" contact
// attributes, ported from the CrmB mockup. Values are matched by keyword
// after normalising accents/case so "Ganado pagado", "Ganado-Pagado" and
// "ganado_pagado" all land on the same colour. Fixed hexes on purpose — the
// mockup keeps these identical regardless of theme.
const NEUTRAL = { bg: '#e8edf1', text: '#5f6f7f', dot: '#93a2ae' };

const STAGE_RULES = [
  { test: /perdid|spam/, color: { bg: '#f7e4e1', text: '#a34532', dot: '#c05a45' } },
  { test: /ganad|pagad/, color: { bg: '#d6ece0', text: '#1e6047', dot: '#26795a' } },
  { test: /cotiz|proveedor/, color: { bg: '#f6ecd6', text: '#7a5810', dot: '#b58218' } },
  { test: /agend|prospect/, color: { bg: '#dcefe6', text: '#256a51', dot: '#2e8462' } },
  { test: /no contact|sin contact|no_contact/, color: NEUTRAL },
  { test: /contact|colaborador/, color: { bg: '#dfeaf7', text: '#2b5f96', dot: '#3b7fc4' } },
  { test: /nuevo|cliente/, color: { bg: '#d8ecef', text: '#1b5a66', dot: '#24707f' } },
];

export const normalizeStage = value =>
  String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

export const stageColor = value => {
  const key = normalizeStage(value);
  if (!key) return NEUTRAL;
  const rule = STAGE_RULES.find(({ test }) => test.test(key));
  return rule ? rule.color : NEUTRAL;
};

// Attribute keys the contacts screen treats as first-class filters/columns.
// Falls back to any list-type contact attribute whose key contains the hint.
export const TYPE_ATTRIBUTE_HINT = 'tipo';
export const STAGE_ATTRIBUTE_HINT = 'estado';

export const findListAttribute = (attributes, exactKey, hint) => {
  const list = (attributes || []).filter(
    attr => attr.attributeDisplayType === 'list'
  );
  return (
    list.find(attr => attr.attributeKey === exactKey) ||
    list.find(attr => attr.attributeKey?.includes(hint))
  );
};
